import { Pipe, PipeTransform } from '@angular/core';
import { KeyLabelPair } from '../domain/registrator';

@Pipe({
  name: 'enumLabel',
  standalone: true
})
export class EnumLabelPipe implements PipeTransform {

  transform(    
    key: string | number | undefined, // The enum key (e.g., 'CARD', 0)
    options: KeyLabelPair<any>[] // The array of {key, label} pairs (e.g., paymentOptions)
  ): string | undefined {
    if (key === undefined || key === null || options === undefined || options === null) {
      return '';
    }
    const foundOption = options.find(option => option.key === key);
    return foundOption ? foundOption.label : '';
  }
}
